export default __webpack_public_path__ + "static/media/medical-doctor-with-big-teeth-illustration-concept-free-vector.092729ce.webp";